// CourseTenses.jsx
import React, { useEffect, useMemo, useState } from "react";
import "./CourseTenses.css";
import logo from './bluelogo.png'
import { useActivityTracker } from "./hooks/useActivityTracker";
import example_video from "./freetrial__videos/descriptive__paragraph.mp4";
import SimplePastCourse from "./CourseContainer/tenses/SimplePastCourse.mp4";
import SimplePastExercise from "./CourseContainer/tenses/SimplePastExercise.mp4";
import PresentPerfectCourse from "./CourseContainer/tenses/PresentPerfectCourse.mp4";
import PresentPerfectExercise from "./CourseContainer/tenses/PresentPerfectExercise.mp4";
import PresentContinuousCourse from "./CourseContainer/tenses/PresentContinuousCourse.mp4";
import FuturePerfectCourse from "./CourseContainer/tenses/FuturePerfectCourse.mp4";
import IntroductionToTenses from "./CourseContainer/tenses/IntroductionToTenses.mp4";

import SimpleFutureCourse from "./CourseContainer/tenses/SimpleFutureCourse.mp4";
import SimpleFutureExercise from "./CourseContainer/tenses/SimpleFutureExercise.mp4";
import FutureContinuousCourse from "./CourseContainer/tenses/FutureContinuousCourse.mp4";
import PastPerfectCourse from "./CourseContainer/tenses/PastPerfectCourse.mp4";
import PastPerfectExercise from "./CourseContainer/tenses/PastPerfectExercise.mp4";
import TensesIntro from "./CourseContainer/tenses/IntroductionToTenses.mp4";
// import PastContinuousCourse from "./CourseContainer/tenses/PastContinuousCourse.mp4";
// import PastContinuousExercise from "./CourseContainer/tenses/PastContinuousExercise.mp4";
import SimplePresent1 from "./CourseContainer/tenses/SimplePresent1.mp4";
import SimplePresent2 from "./CourseContainer/tenses/SimplePresent2.mp4";
import SimplePresentExercise from "./CourseContainer/tenses/SimplePresentExercise.mp4";
import MixedTensesExercises1 from "./CourseContainer/tenses/MixedTensesExercises1.mp4";
import MixedTensesExercises2 from "./CourseContainer/tenses/MixedTensesExercises2.mp4";

// pdfs
import SimplePastPdf from "./CourseContainer/pdfs/tenses/simple past summary for academy.pdf";
import FutureContinuousPdf from "./CourseContainer/pdfs/tenses/future countinuos summary for academy.pdf";
import FuturePerfectPdf from "./CourseContainer/pdfs/tenses/Future perfect summary for academy.pdf";
import PastPerfectPdf from "./CourseContainer/pdfs/tenses/Past perfect summary for academy.pdf";
import PastContinuousPdf from "./CourseContainer/pdfs/tenses/PastContinuousPdf.pdf";
import PresentContinuousPdf from "./CourseContainer/pdfs/tenses/present CONTINUOUS summary for academy.pdf";
import PresentPerfectPdf from "./CourseContainer/pdfs/tenses/present perfect summary for Academy.pdf";
import SimpleFuturePdf from "./CourseContainer/pdfs/tenses/simple future summary for academy.pdf";
import SimplePresentPdf from "./CourseContainer/pdfs/tenses/SIMPLE PRESENT summary for academy.pdf";
import MixedTensesPart1Pdf from "./CourseContainer/pdfs/tenses/MixedTensesPart1Pdf.pdf";
import MixedTensesPart2Pdf from "./CourseContainer/pdfs/tenses/MixedTensesPart2Pdf.pdf";




import Footer from "./Footer";
import Header from "./Header";

export default function CourseTenses() {
  const { trackActivity } = useActivityTracker();
  const tabs = ["Present", "Past", "Future", "Exams"];
  const [activeTab, setActiveTab] = useState("Exams");

  useEffect(() => {
    trackActivity('course_access', 'tenses');
  }, []);
  const [query, setQuery] = useState("");

  // which accordion cards are open
  const [openIds, setOpenIds] = useState(() => new Set());

  // only one inline video open at a time
  const [openInlineVideo, setOpenInlineVideo] = useState(null); // { lessonId, itemId, videoSrc, title, subtitle }

  const lessons = useMemo(
    () => [
      {
        id: "introduction-to-tenses",
        title: "Introduction",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "intro-p1",
            label: "Click Play >>",
            duration: "12:54 min",
            videoSrc: TensesIntro,
          },
        ],
      },
      {
        id: "past-simple",
        title: "Past Simple",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "ps-p1",
            label: "Part 1",
            duration: "12:41 min",
            videoSrc: SimplePastCourse,
          },
          {
            id: "ps-p2",
            label: "Part 2",
            duration: "09:13 min",
            videoSrc: SimplePastExercise,
          },
          // {
          //   id: "ps-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   pdfSrc: SimplePastPdf,
          // },
        ],
      },
      {
        id: "past-perfect",
        title: "Past Perfect",
        // subtitle: "Usage + form + examples",
        // meta: ["1 lesson", "9 min"],
        items: [
          {
            id: "ppast-p1",
            label: "Part 1",
            duration: "10:54 min",
            videoSrc: PastPerfectCourse,
          },
          {
            id: "ppast-p2",
            label: "Part 2",
            duration: "05:09 min",
            videoSrc: PastPerfectExercise,
          },
          // {
          //   id: "ppast-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   pdfSrc: PastPerfectPdf,
          // },
        ],
      },
      {
        id: "past-continuous",
        title: "Past Continuous",
        // subtitle: "Usage + form + examples",
        // meta: ["1 lesson", "9 min"],
        items: [
          {
            id: "pcast-p1",
            label: "Part 1",
            duration: "10:54 min",
            // videoSrc: PastContinuousCourse,
          },
          {
            id: "pcast-p2",
            label: "Part 2",
            duration: "05:09 min",
            // videoSrc: PastContinuousExercise,
          },
          // {
          //   id: "pcast-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   pdfSrc: PastContinuousPdf,
          // },
        ],
      },
      {
        id: "simple-present",
        title: "Simple Present",
        // subtitle: "Part 1 / Part 2 + Exercises",
        // meta: ["3 parts", "+ exercises", "12 min"],
        items: [
          {
            id: "sp-p1",
            label: "Part 1",
            duration: "13:22 min",
            videoSrc: SimplePresent1,
          },
          {
            id: "sp-p2",
            label: "Part 2",
            duration: "09:17 min",
            videoSrc: SimplePresent2,
          },
          {
            id: "sp-p3",
            label: "Part 3",
            duration: "08:17 min",
            videoSrc: SimplePresentExercise,
          },
          // {
          //   id: "sp-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   pdfSrc: SimplePresentPdf,
          // },
        ],
      },
      {
        id: "present-perfect",
        title: "Present Perfect",
        // subtitle: "Usage + form + signals",
        // meta: ["1 lesson", "12 min"],
        items: [
          {
            id: "pp-p1",
            label: "Part 1",
            duration: "10:53 min",
            videoSrc: PresentPerfectCourse,
          },
          {
            id: "pp-p2",
            label: "Part 2",
            duration: "06:09 min",
            videoSrc: PresentPerfectExercise,
          },
          // {
          //   id: "pp-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   pdfSrc: PresentPerfectPdf,
          // },
        ],
      },
      {
        id: "present-continuous",
        title: "Present Continuous",
        // subtitle: "Usage + form + examples",
        // meta: ["1 lesson", "9 min"],
        items: [
          {
            id: "pc-lesson",
            label: "Lesson",
            duration: "13:41 min",
            videoSrc: PresentContinuousCourse,
          },
          // {
          //   id: "pc-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   pdfSrc: PresentContinuousPdf,
          // },
        ],
      },
      {
        id: "simple-future",
        title: "Simple Future",
        // subtitle: "Usage + form + examples",
        // meta: ["1 lesson", "8 min"],
        items: [
          {
            id: "sf-p1",
            label: "Part 1",
            duration: "11:18 min",
            videoSrc: SimpleFutureCourse,
          },
          {
            id: "sf-p2",
            label: "Part 2",
            duration: "04:40 min",
            videoSrc: SimpleFutureExercise,
          },
          // {
          //   id: "sf-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   pdfSrc: SimpleFuturePdf,
          // },
        ],
      },
      {
        id: "future-perfect",
        title: "Future Perfect",
        // subtitle: "Usage + form + examples",
        // meta: ["1 lesson", "9 min"],
        items: [
          {
            id: "fp-lesson",
            label: "Lesson",
            duration: "08:57 min",
            videoSrc: FuturePerfectCourse,
          },
          // {
          //   id: "fp-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   pdfSrc: FuturePerfectPdf,
          // },
        ],
      },
      {
        id: "future-continuous",
        title: "Future Continuous",
        // subtitle: "Usage + form + examples",
        // meta: ["1 lesson", "8 min"],
        items: [
          {
            id: "fc-lesson",
            label: "Lesson",
            duration: "04:53 min",
            videoSrc: FutureContinuousCourse,
          },
          // {
          //   id: "fc-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   pdfSrc: FutureContinuousPdf,
          // },
        ],
      },
      {
        id: "all-tenses-exercises1",
        title: "Mixed Tenses Part 1",
        // subtitle: "Practice",
        // meta: ["1 lesson", "8 min"],
        items: [
          {
            id: "mt-pdf",
            label: "Download Exercises",
            kind: "exercise",
            pdfSrc: MixedTensesPart1Pdf,
          },
          {
            id: "mt-lesson",
            label: "Watch Correction",
            kind: "Lesson",
            duration: "12:24 min",
            videoSrc: MixedTensesExercises1,
          },
        ],
      },
      {
        id: "all-tenses-exercises2",
        title: "Mixed Tenses Part 2",
        // subtitle: "Practice",
        // meta: ["1 lesson", "8 min"],
        items: [
          {
            id: "mt1-pdf",
            label: "Download Exercises",
            kind: "exercise",
            pdfSrc: MixedTensesPart2Pdf,
          },
          {
            id: "mt1-lesson",
            label: "Watch Correction",
            kind: "Lesson",
            duration: "09:39 min",
            videoSrc: MixedTensesExercises2,
          },
        ],
      },
    ],
    []
  );

  const filteredLessons = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return lessons;
    return lessons.filter((l) =>
      `${l.title} ${l.subtitle}`.toLowerCase().includes(q)
    );
  }, [lessons, query]);

  const toggleAccordion = (lessonId) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(lessonId)) next.delete(lessonId);
      else next.add(lessonId);
      return next;
    });
  };

  const toggleInlineVideo = ({
    lessonId,
    itemId,
    videoSrc,
    title,
    subtitle,
  }) => {
    setOpenInlineVideo((curr) => {
      if (curr && curr.lessonId === lessonId && curr.itemId === itemId)
        return null;
      return { lessonId, itemId, videoSrc, title, subtitle };
    });
  };

  // icons defined INSIDE this file (simple)
  const IconPlay = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="#4b5563" />
    </svg>
  );

  const IconPlaySmall = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="#6b7280" />
    </svg>
  );

  const IconChevronDown = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M7 10l5 5 5-5H7Z" fill="#6b7280" />
    </svg>
  );

  const IconCheck = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path
        d="M9.2 16.2 5.5 12.5 4.1 13.9l5.1 5.1L20 8.2 18.6 6.8 9.2 16.2Z"
        fill="#16a34a"
      />
    </svg>
  );
  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, []);

  window.onscroll = function () {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");

    if (window.scrollY > 50) {
      // Change 30 to your desired scroll distance

      headerLogo.style.width = "60px";
      // header.style.padding = "10px 100px";
      header.style.transition = "background 0.3s ease-in-out";
    } else {
      if (window.innerWidth < "668") {
        headerLogo.style.width = "60px";
        header.style.background = "white";
        // header.style.padding = "20px 100px";
      } else {
        headerLogo.style.width = "60px";
        header.style.background = "white";
      }
    }
  };
  useEffect(() => {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");
    headerLogo.style.width = "60px";
    header.style.background = "white";
    // header.style.padding = "20px 100px";
  }, []);
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <div className="tensesContainer">
       <header  id="All__courses__header">
        <a href="https://toustousacademy.com/">
          <img className="tenses__header__img" src={logo} alt="" />
        </a>
        <ul>
          <a href="/" onClick={scrollToTop}>
            <li>Home</li>
          </a>
          <a href="/#about">
            <li>About</li>
          </a>
          <a href="/#feedback">
            <li>Feedback</li>
          </a>
        </ul>
      </header>
      <div className="tp-page">
        <div className="tp-container">
          <header className="tp-header">
            <h1 className="tp-title">Tenses</h1>
            <p className="tp-subtitle">
              Short lessons + practice + correction.
            </p>
          </header>

          <div className="tp-toolbar">
            <div className="tp-tabs">
              {tabs.map((t) => (
                <button
                  key={t}
                  className={`tp-tab ${activeTab === t ? "is-active" : ""}`}
                  onClick={() => setActiveTab(t)}
                  type="button"
                >
                  <span>{t}</span>
                  {(t === "Exams" || t === "Future")}
                </button>
              ))}
            </div>
          </div>

          <main className="tp-list">
            {filteredLessons.map((lesson) => {
              const isOpen = openIds.has(lesson.id);

              return (
                <article key={lesson.id} className="tp-card">
                  {/* Accordion header */}
                  <button
                    className="tp-accHeader"
                    type="button"
                    onClick={() => toggleAccordion(lesson.id)}
                  >
                    <div className="tp-accLeft">
                      <div className="tp-playCircle" aria-hidden="true">
                        <IconPlay />
                      </div>

                      <div className="tp-cardMain">
                        <div className="tp-cardTitle">{lesson.title}</div>
                        <div className="tp-cardSub">{lesson.subtitle}</div>

                        {lesson.meta && (
                          <div className="tp-pills">
                            {lesson.meta.map((m) => (
                              <span key={m} className="tp-pill">
                                {m}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <span className={`tp-accChev ${isOpen ? "is-open" : ""}`}>
                      <IconChevronDown />
                    </span>
                  </button>

                  {/* Accordion body */}
                  <div className={`tp-accBody ${isOpen ? "is-open" : ""}`}>
                    {lesson.items.map((it) => {
                      const isExercise = it.kind === "exercise";
                      const isThisVideoOpen =
                        openInlineVideo?.lessonId === lesson.id &&
                        openInlineVideo?.itemId === it.id;

                      return (
                        <div key={it.id} className="tp-itemBlock">
                          <div
                            className={`tp-itemRow ${
                              isExercise ? "is-exercise" : ""
                            }`}
                          >
                            <div className="tp-itemLeft">
                              <div
                                className={
                                  isExercise
                                    ? "tp-checkCircle"
                                    : "tp-smallPlayCircle"
                                }
                                aria-hidden="true"
                              >
                                {isExercise ? <IconCheck /> : <IconPlaySmall />}
                              </div>
                              <div className="tp-itemTitle">{it.label}</div>
                            </div>

                            <div className="tp-itemRight">
                              <div className="tp-partDur">
                                {it.duration || ""}
                              </div>

                              {isExercise ? (
                                <a
                                  className="tp-playBtn tp-playBtnLight"
                                  href={it.pdfSrc}
                                  download
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  Download PDF
                                  {/* <span className="tp-playBtnChev">›</span> */}
                                </a>
                              ) : (
                                <button
                                  className="tp-playBtn"
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleInlineVideo({
                                      lessonId: lesson.id,
                                      itemId: it.id,
                                      videoSrc: it.videoSrc,
                                      title:
                                        it.label === "Click Play >>"
                                          ? lesson.title
                                          : `${lesson.title} — ${it.label}`,
                                      subtitle: lesson.subtitle,
                                    });
                                  }}
                                >
                                  {isThisVideoOpen ? "Hide" : "Play"}{" "}
                                  <span className="tp-playBtnChev">›</span>
                                </button>
                              )}
                            </div>
                          </div>

                          {/* inline video under the row */}
                          {isThisVideoOpen && (
                            <div className="tp-inlineVideoWrap">
                              <div className="tp-inlineVideoHeader">
                                <div className="tp-inlineVideoTitle">
                                  {openInlineVideo.title}
                                </div>
                                <div className="tp-inlineVideoSub">
                                  {openInlineVideo.subtitle}
                                </div>
                              </div>

                              <video
                                key={openInlineVideo.videoSrc}
                                className="tp-inlineVideo"
                                controlsList="nodownload noplaybackrate"
                                disablePictureInPicture
                                onContextMenu={(e) => e.preventDefault()}
                                controls
                                autoPlay
                                src={openInlineVideo.videoSrc}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </article>
              );
            })}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
